module.exports = __webpack_public_path__ + "img/sweden-lung-cancer-female.4ab9ddcf.png";